import { useCallback, useEffect, useState } from 'react';

import localStorage from 'utils/localStorage';
import jwt from 'utils/jwt';

export const useAuthToken = () => {
  const [token, setToken] = useState(localStorage.getAuthToken() || '');
  const [decodedToken, setDecodedToken] = useState(jwt.decode(token));

  const handleStorageChange = useCallback((event) => {
    if (event.key === localStorage.AUTH_TOKEN_STORAGE_KEY) {
      const newToken = event.newValue;
      setToken(newToken);
      setDecodedToken(jwt.decode(newToken));
    }
  }, []);

  useEffect(() => {
    window.addEventListener('storage', handleStorageChange, false);

    return () => {
      window.removeEventListener('storage', handleStorageChange, false);
    };
  }, [handleStorageChange]);

  return {
    token,
    decodedToken,
    isExpired: () => Date.now() >= (decodedToken?.exp || 0) * 1000,
  };
};
